<div class="sidebar" data-color="blue">
  <div class="logo">
    <a [routerLink]="['/']" class="simple-text logo-normal">
      <img src="../assets/img/logo_nasti_orizzontale.png" />
    </a>
  </div>
  <div class="navbar-minimize">
    <button
      type="button"
      class="btn btn-link btn-icon"
      (click)="minimizeSidebar()"
      [attr.aria-label]="sidebarMiniActive() ? 'Apri sidebar' : 'Chiudi sidebar'"
    >
      <i class="now-ui-icons" [ngClass]="sidebarMiniActive() ? 'arrows-1_minimal-right' : 'arrows-1_minimal-left'"></i>
    </button>
  </div>
  <div class="sidebar-wrapper">
    <div class="user">
      <div class="photo"><img src="../assets/img/img_profilo.png" /></div>
      <div class="info">
        <a
          data-bs-toggle="collapse"
          href="javascript: void(0)"
          (click)="isCollapsed.update((v) => !v)"
          [attr.aria-expanded]="!isCollapsed()"
          aria-controls="collapseExample"
        >
          <span> ACCOUNT <b class="caret"></b> </span>
        </a>
        <div class="collapse" id="collapseExample" [ngbCollapse]="isCollapsed()">
          <ul class="nav">
            <li>
              <a
                routerLinkActive="active"
                class="d-flex align-items-center"
                [routerLink]="['/account/modifica-password']"
              >
                <span class="sidebar-mini-icon"><i class="now-ui-icons loader_gear"></i></span>
                <span class="sidebar-normal">Gestione password</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <ul class="nav">
      @for (menuitem of menuItems(); track menuitem.id) {
        <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
          <!--If is a single link-->
          @if (menuitem.type === 'link') {
            <a [routerLink]="menuitem.fullPath">
              <i class="now-ui-icons {{ menuitem.icontype }}"></i>
              <p>{{ menuitem.title }}</p>
            </a>
          }
          <!--If it have a submenu-->
          @if (menuitem.type === 'sub') {
            <a
              data-bs-toggle="collapse"
              href="javascript:void(0)"
              (click)="toggleCollapse(menuitem.collapse!)"
              [attr.aria-expanded]="!collapsedSections()[menuitem.collapse!]"
            >
              <i class="now-ui-icons {{ menuitem.icontype }}"></i>
              <p>{{ menuitem.title }}<b class="caret"></b></p>
            </a>
          }
          <!--Display the submenu items-->
          @if (menuitem.type === 'sub' && menuitem.children) {
            <div
              [id]="menuitem.collapse"
              class="collapse sidebar-submenu-item"
              [ngbCollapse]="collapsedSections()[menuitem.collapse!]"
            >
              <ul class="nav">
                @for (childitem of menuitem.children; track childitem.id) {
                  <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
                    <a [routerLink]="childitem.fullPath">
                      <span class="sidebar-mini-icon">
                        @if (childitem.icontype) {
                          <i class="now-ui-icons {{ childitem.icontype }}"></i>
                        }
                        @if (!childitem.icontype) {
                          {{ childitem.ab }}
                        }
                      </span>
                      <span class="sidebar-normal">{{ childitem.title }}</span>
                    </a>
                  </li>
                }
              </ul>
            </div>
          }
        </li>
      }
    </ul>
  </div>
</div>
